export enum FormMode {
  New = "new",
  Edit = "edit",
  Clone = "clone"
}

export enum ConfirmationModals {
  NoRequirements = "no_requirements",
  Misalignment = "misalignment",
  Public = "public",
  QuestionsChanged = "questions_changed"
}
